import { memo, type ReactNode } from 'react'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

import { InviteMemberForm } from './invite-member-form.molecule'
import type { InviteMemberDialogProps } from './members.interface'

/**
 * A dialog form for inviting new members to an organization.
 * Includes email input and role selection with form validation.
 */
const InviteMemberDialogBase: React.FC<InviteMemberDialogProps> = ({
  isOpen,
  onOpenChange,
  onInvite,
  isLoading = false,
  className,
}): ReactNode => (
  <Dialog open={isOpen} onOpenChange={onOpenChange}>
    <DialogContent className={cn('invite-member-dialog sm:max-w-md', className)}>
      <DialogHeader>
        <DialogTitle className="invite-member-dialog-title">Invite Member</DialogTitle>
        <DialogDescription className="invite-member-dialog-description">
          Send an invitation to add a new member to your organization.
        </DialogDescription>
      </DialogHeader>
      <InviteMemberForm
        onSubmit={onInvite}
        onCancel={() => onOpenChange(false)}
        isLoading={isLoading}
        shouldReset={!isOpen}
      />
    </DialogContent>
  </Dialog>
)

export const InviteMemberDialog = memo(InviteMemberDialogBase)

InviteMemberDialog.displayName = 'InviteMemberDialog'
